import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

const ChartParagraph = ({ chart, chartType }) => {
  let options = {
    chart: {
      type: chartType,
    },
    title: {
      text: chart.caption,
    },
    series: chartDataToSeriesData(chart.tableValue, chartType),
  }

  if (chartType === 'donut') {
    options.chart.type = 'pie'
    options.plotOptions = {
      pie: {
        innerSize: '50%',
      },
    }
  }

  return (
    <>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </>
  )
}

const chartDataToSeriesData = (data, chartType) => {
  if (!data) {
    return []
  }
  let seriesData = []
  const rows = data.split('|')

  // 0 is data header
  // last row is data Caption
  rows.forEach((row, index) => {
    if (index > 0 && row.length > 0 && index < rows.length - 1) {
      seriesData.push(formatRowData(row.split(',')))
    }
  })

  switch (chartType) {
    case 'pie':
    case 'donut':
    case 'spline':
      return [{ data: seriesData }]
    default:
      return seriesData.map(row => {
        return {
          name: row[0],
          data: row.slice(1),
        }
      })
  }
}

const formatRowData = row => {
  return row.map(column => {
    if (isNaN(column)) {
      return column
    }

    return Number.parseInt(column)
  })
}

ChartParagraph.propTypes = {
  chartType: PropTypes.string.isRequired,
  chart: PropTypes.shape({
    tableValue: PropTypes.string.isRequired,
  }),
}

const fragments = {
  paragraph: gql`
    fragment ChartParagraphFragment on ParagraphChart {
      id
      chart: fieldChart {
        tableValue
        caption
      }
      chartType: fieldChartType
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { ChartParagraph, fragments }
